// Shared colours for the Insights tab.
//
// Scores use green/yellow/red based on the thresholds below.
// Non-score UI elements use neutral greys.
// Combined overview charts use blue because they are summaries rather than score indicators.

/** Score band thresholds. */
export const SCORE_THRESHOLDS = {
    GOOD_MIN: 75, // 75–100%
    AVERAGE_MIN: 50, // 50–74%; below 50% is bad
} as const;

/** Colours used for score bands. */
export const SCORE_COLORS = {
    good: 'green.60',
    average: 'yellow.60',
    bad: 'red.90',
} as const;

/** Neutral colour for badges, chips and non-score UI. */
export const NEUTRAL_COLOR = 'gray.30';

/** Lighter neutral colour for empty chart tracks. */
export const NEUTRAL_TRACK = 'gray.10';

/**
 * Combined charts use one neutral blue because they show an overall summary,
 * not an individual good/bad score.
 */
export const COMBINED_BAR_COLOR = 'leadblue.100';
export const COMBINED_TEXT_COLOR = 'devblue.100';

/**
 * "Other" represents several low-frequency themes grouped together,
 * so it is shown differently from actual ranked themes.
 */
export const OTHER_THEME_BAR_COLOR = NEUTRAL_COLOR;

/** Returns the colour for a percentage score. */
export const getScoreColor = (percentage: number): string => {
    if (percentage >= SCORE_THRESHOLDS.GOOD_MIN) return SCORE_COLORS.good;
    if (percentage >= SCORE_THRESHOLDS.AVERAGE_MIN) return SCORE_COLORS.average;

    return SCORE_COLORS.bad;
};
